import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

export const DynamicImage = ({ image = {}, src = '', alt, className, propsImage = {} }) => {
	if (image?.gatsbyImageData) {
		return (
			<GatsbyImage
				image={image.gatsbyImageData}
				backgroundColor='transparent'
				alt={alt}
				className={className}
				src={image.file?.url || ''}
				{...propsImage}
			/>
		)
	}

	const url = image?.file?.url || src
	return <img src={url} alt={alt} className={className} {...propsImage} />
}

export default DynamicImage
